import { render, staticRenderFns } from "./collapseInfo.vue?vue&type=template&id=142e2596&scoped=true"
import script from "./collapseInfo.vue?vue&type=script&lang=js"
export * from "./collapseInfo.vue?vue&type=script&lang=js"
import style0 from "./collapseInfo.vue?vue&type=style&index=0&id=142e2596&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "142e2596",
  null
  
)

export default component.exports